import React, { useContext } from 'react';
import { IconButtonProps } from '@mui/material';
import { UiContext } from 'uiContext';
import { IconButton as MuiIconButton } from '@mui/material';

export default function IconButton(props: IconButtonProps) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <MuiIconButton
      {...props}
      sx={{
        'p': sp.s20,
        'borderRadius': '4px',
        'color': 'primary.contrastText',
        '& .MuiTouchRipple-root .MuiTouchRipple-child': {
          borderRadius: '4px',
        },
        ...props?.sx,
      }}
    />
  );
}
